import Vue from 'vue'
const Eventbus = new Vue()
export default Eventbus
